import { RachelStoreState } from './rachel.store';

export const selectIsRachelOpen = (state: RachelStoreState) => state.isOpen;
export const selectOpenRachel = (state: RachelStoreState) => state.open;
export const selectCloseRachel = (state: RachelStoreState) => state.close;
export const selectActiveChatIdForTeam =
  (teamId: string | null | undefined) => (state: RachelStoreState) =>
    state.getActiveChatIdForTeam(teamId);
export const selectIsRachelInputFocused = (state: RachelStoreState) => state.isInputFocused;
export const selectIsRachelCompacting = (state: RachelStoreState) => state.isCompacting;
export const selectSetIsRachelCompacting = (state: RachelStoreState) => state.setIsCompacting;
export const selectIsMessageInterrupted = (messageId: string) => (state: RachelStoreState) =>
  Boolean(state.interruptedMessageIds[messageId]);
export const selectRachelFocusedLabel = (state: RachelStoreState) =>
  state.focusedLabels.at(-1)?.label ?? null;
export const selectRachelDismissedPageContext = (state: RachelStoreState) =>
  state.dismissedPageContext;
export const selectRachelDockedWidth = (state: RachelStoreState) => state.dockedLayout.width;
export const selectRachelDockedLayout = (state: RachelStoreState) => state.dockedLayout;
export const selectSetRachelDockedLayout = (state: RachelStoreState) => state.setDockedLayout;
